import React, { useEffect } from 'react';
import FormStep from './FormStep';

const ThankYou = () => {
  useEffect(() => {
    // Clear any stored booking ID as the booking is now complete
    try {
      localStorage.removeItem('lde_booking_id');
      console.log('Cleared booking ID from localStorage');
    } catch (err) {
      console.error('Failed to clear booking ID from localStorage:', err);
    }
    
    // Get the current site URL (to handle multisite installations)
    const currentSiteUrl = window.location.origin;
    const currentPath = window.location.pathname;
    
    // Extract the site path if we're on a subsite
    let sitePath = '';
    // Match patterns like /site-name/ or /events/event-name/
    const pathMatch = currentPath.match(/^\/([^/]+\/[^/]+\/|[^/]+\/)/);
    if (pathMatch) {
      sitePath = pathMatch[0];
    }
    
    // Construct the thank-you page URL
    const thankYouPage = `${currentSiteUrl}${sitePath}thank-you`;
    console.log('Redirecting to thank-you page:', thankYouPage);
    
    // Redirect to the thank-you page
    window.location.href = thankYouPage;
  }, []);

  return (
    <FormStep title="Thank You for Your Booking">
      <div className="thank-you-container">
        <p>Redirecting to confirmation page...</p>
      </div>
    </FormStep>
  );
};

export default ThankYou;
